import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import checkAuth, { clearSession } from './AuthCheck';

/**
 * Route guard for the admin area.
 *
 * Redirecting from an effect lets the protected page paint for a frame first,
 * which is how a signed-out visitor ended up staring at an admin panel whose
 * buttons all failed. Returning <Navigate> instead renders nothing at all.
 */
const RequireAuth = ({ children }) => {
  const location = useLocation();

  if (!checkAuth()) {
    clearSession(); // drop the expired token so the next visit starts clean
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default RequireAuth;
